module.exports = __webpack_public_path__ + "img/mms-3.a108ea4f.jpg";